import { t } from "i18next";
import * as z from "zod";

/**
 * Demande maker-checker d'émission / retrait e-money (guide §5.5).
 * Montant saisi en unité majeure ; `bankReference` obligatoire (422 sinon).
 */
export const createEmoneyApprovalSchema = () =>
  z.object({
    walletId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    amount: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .positive({ message: t("invalidFieldError") }),
    bankReference: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    reason: z.string().trim().min(1, { message: t("requiredFieldError") }),
  });

export type EmoneyApprovalFormValues = z.infer<
  ReturnType<typeof createEmoneyApprovalSchema>
>;
